export const getStripePublicKey = (): string => {
  const stripePublicKey = process.env.STRIPE_PUBLIC_KEY;
  if (typeof stripePublicKey !== "string" || stripePublicKey === "") {
    // biome-ignore lint/style/useConsistentBuiltinInstantiation :[AUTOMATICALLY-INSERTED] Use new Error() instead of Error().
    throw Error("You need to provide a Stripe Public Key as `STRIPE_PUBLIC_KEY` env variable.");
  }
  return stripePublicKey;
};
